export default "__VITE_ASSET__BRjZIlQg__"